/* global axios */
import ApiClient from './ApiClient';

// Multipart requests (media upload) don't go through Rails' ParamsWrapper (JSON-only, see
// config/initializers/wrap_parameters.rb), so the nested `evolution_broadcast[...]` keys have
// to be built by hand here. Plain JSON updates (no File in payload) skip FormData entirely.
const appendNested = (formData, key, value) => {
  if (value === undefined || value === null) return;

  if (Array.isArray(value)) {
    value.forEach(item => formData.append(`${key}[]`, item));
  } else if (typeof value === 'object' && !(value instanceof File)) {
    Object.entries(value).forEach(([childKey, childValue]) =>
      appendNested(formData, `${key}[${childKey}]`, childValue)
    );
  } else {
    formData.append(key, value);
  }
};

const buildFormData = payload => {
  const formData = new FormData();
  Object.entries(payload).forEach(([key, value]) =>
    appendNested(formData, `evolution_broadcast[${key}]`, value)
  );
  return formData;
};

const hasFile = payload => payload.media instanceof File;

class EvolutionBroadcastsAPI extends ApiClient {
  constructor() {
    super('evolution_broadcasts', { accountScoped: true });
  }

  create(payload) {
    if (hasFile(payload)) {
      return axios.post(this.url, buildFormData(payload));
    }
    return axios.post(this.url, { evolution_broadcast: payload });
  }

  update(id, payload) {
    if (hasFile(payload)) {
      return axios.patch(`${this.url}/${id}`, buildFormData(payload));
    }
    return axios.patch(`${this.url}/${id}`, { evolution_broadcast: payload });
  }

  activate(id) {
    return axios.post(`${this.url}/${id}/activate`);
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }
}

export default new EvolutionBroadcastsAPI();
